// frontend/src/ActivityLog/DateRangeFilter.jsx — one Polaris filter for a date range: a button that says the range,
// opening a Popover with presets, a range DatePicker, Clear and Apply. Values are "YYYY-MM-DD" or "" (the URL filters).
import React, { useState } from 'react';
import { BlockStack, Box, Button, DatePicker, InlineStack, Popover, Text } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';
import { PRESETS, fromYmd, presetRange, rangeLabel, toYmd } from './dateRange';

const monthOf = (date) => ({ month: date.getMonth(), year: date.getFullYear() });

export default function DateRangeFilter({ label, since, until, onChange }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState({ start: null, end: null });
  const [{ month, year }, setMonthYear] = useState(() => monthOf(fromYmd(since) || new Date()));
  const today = new Date();

  const show = () => {
    const start = fromYmd(since); const end = fromYmd(until);
    setPending({ start, end: end || start });
    setMonthYear(monthOf(end || start || today));
    setOpen(true);
  };
  const emit = (range) => { onChange(range); setOpen(false); };
  const apply = () => emit({ since: pending.start ? toYmd(pending.start) : '', until: pending.end ? toYmd(pending.end) : '' });
  const clear = () => emit({ since: '', until: '' });
  const preset = (key) => emit(presetRange(key, today));

  const activator = (
    <BlockStack gap="100">
      <Text as="span" variant="bodyMd">{label}</Text>
      <Button icon={CalendarIcon} disclosure fullWidth textAlign="left" onClick={() => (open ? setOpen(false) : show())} pressed={Boolean(since || until)}>
        {rangeLabel(since, until)}
      </Button>
    </BlockStack>
  );

  return (
    <Popover active={open} activator={activator} onClose={() => setOpen(false)} preferredAlignment="left" fluidContent>
      {/* The overlay sizes itself to the DatePicker's unbounded max-content width, so bound it (Polaris's date-range pattern does the same). */}
      <Box padding="400" maxWidth="480px">
        <InlineStack gap="400" blockAlign="start">
          <BlockStack gap="100">
            {PRESETS.map(([key, text]) => <Button key={key} variant="tertiary" size="slim" textAlign="left" onClick={() => preset(key)}>{text}</Button>)}
          </BlockStack>
          <BlockStack gap="300">
            <DatePicker month={month} year={year} onMonthChange={(m, y) => setMonthYear({ month: m, year: y })}
              selected={pending.start ? pending : undefined} onChange={setPending} allowRange disableDatesAfter={today} />
            <InlineStack align="end" gap="200">
              <Button onClick={clear} disabled={!since && !until && !pending.start}>Clear</Button>
              <Button variant="primary" onClick={apply} disabled={!pending.start}>Apply</Button>
            </InlineStack>
          </BlockStack>
        </InlineStack>
      </Box>
    </Popover>
  );
}
